/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInvite,
    JsonInviteFromJSON,
    JsonInviteFromJSONTyped,
    JsonInviteToJSON,
} from './JsonInvite';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonInvite
 */
export interface ApiResultOfListOfJsonInvite {
    /**
     * 
     * @type {Array<JsonInvite>}
     * @memberof ApiResultOfListOfJsonInvite
     */
    data?: Array<JsonInvite>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInvite
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonInvite
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInvite
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonInvite
     */
    result?: ApiResultOfListOfJsonInviteResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonInviteResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonInviteFromJSON(json: any): ApiResultOfListOfJsonInvite {
    return ApiResultOfListOfJsonInviteFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonInviteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonInvite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonInviteFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonInviteToJSON(value?: ApiResultOfListOfJsonInvite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonInviteToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

